export enum SurveyName {
  REMOTE_CONTROL = 'REMOTE_CONTROL',
}
